export default {
      id: "obslujen-usage",
      viewBox: "0 0 43 43",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#obslujen",
      toString: function () {
        return this.url;
      }
    }